export default __webpack_public_path__ + "static/media/hero-pic.0f86fcb5.png";